import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {IS_MOBILE, WINDOW, NAVIGATOR, DOCUMENT} from '../../constants/environment';
import Wrapper from '../../components/wrapper';
import BodyControl from "../../components/body";
import Cta from "../../containers/cta";
import * as blocks from "../../blocks";

import './styles.css';

import IconOpenBlack from "./icon-open-black.png";
import IconOpenWhite from "./icon-open-white.png";

export default class PromoAndButtonModalWindow extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    linkItem: PropTypes.string,
    deleteIconOnPromo: PropTypes.bool,
    promo: PropTypes.shape({
      pcDescription: PropTypes.string,
      mbDescription: PropTypes.string,
      pcSrc: PropTypes.string,
      mbSrc: PropTypes.string,
      videoSrc: PropTypes.string,
      loop: PropTypes.bool,
      pcLayout: PropTypes.string,
      mbLayout: PropTypes.string,
      backgroundColor: PropTypes.string,
      ctaButton: PropTypes.array,
    }),
    linkButtonText: PropTypes.shape({
      linkText: PropTypes.string,
      linkType: PropTypes.string,
      buttonColor: PropTypes.string,
      ctaButtonStyle: PropTypes.string,
      additionalClass: PropTypes.string,
    }),
    modal: PropTypes.shape({
      pcContents: PropTypes.array,
      mbContents: PropTypes.array,
      modalId: PropTypes.string,
    }),
    getRef: PropTypes.func,
    hasBackground: PropTypes.bool,
    parentColumn: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    linkItem: 'Promo',
    deleteIconOnPromo: false,
    promo: {
      pcDescription: null,
      mbDescription: null,
      pcSrc: null,
      mbSrc: null,
      videoSrc: null,
      loop: true,
      pcLayout: 'Image-On-Top',
      mbLayout: 'Image-On-Top',
      backgroundColor: null,
      ctaButton: [],
    },
    linkButtonText: {
      linkText: null,
      linkType: 'Button',
      buttonColor: 'Light',
      ctaButtonStyle: 'Standard',
      additionalClass: null,
    },
    modal: {
      pcContents: [],
      mbContents: [],
      modalId: null,
    },
    getRef: null,
    hasBackground: false,
    parentColumn: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      isModalOpened: false,
    }
    this.refs = null;
    this.refsPromoItem = null;
    this.wrapperScrollTop = 0;
  }

  openModal() {
    this.setState({
      isModalOpened: true,
    })

    // EPIServerのプレビュー時のモーダルの位置調整
    let isEpiServerPreview = false;
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'absolute';
          DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          isEpiServerPreview = true;
        }
      }
    }

    if (!isEpiServerPreview) {
      // BODYのスクロール無効化
      BodyControl.openModal();
    }
    // Video停止
    if (this.refsPromoItem) this.refsPromoItem.pauseVideo();
    // FeatureCategoriesの重なり順調整
    if (this.refs) {
      const parentElement = this.refs.closest('.FeatureCategories') || null;
      if (parentElement) {
        parentElement.style.zIndex = 2;
      }
    }
  }

  closeModal() {
    this.setState({
      isModalOpened: false,
    })

    // EPIServerのプレビュー時のモーダルの位置調整
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'static';
          DOCUMENT.body.style.top = 'auto';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = DOCUMENT.body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    BodyControl.closeModal();
    // Video再生
    if (this.refsPromoItem) this.refsPromoItem.playVideo();
    // FeatureCategoriesの重なり順調整
    if (this.refs) {
      const parentElement = this.refs.closest('.FeatureCategories') || null;
      if (parentElement) {
        parentElement.style.zIndex = 1;
      }
    }
  }

  getContentsHeight() {
    // console.log('getContentsHeight', this.refsPromoItem.getContentsHeight());
    if (this.refsPromoItem) {
      return this.refsPromoItem.getContentsHeight();
    } else {
      return null;
    }
  }

  setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.refsPromoItem) {
      this.refsPromoItem.setContainerHeight(height);
    }
  }

  renderCta() {
    const {
      promo,
    } = this.props;
    if (promo && promo.ctaButton && 1 <= promo.ctaButton.length) {
      const components = promo.ctaButton;
      return (
        <ul className="PromoAndButtonModalWindow__list">
          {(()=> {
            return (
              components.map((component, index) => {
                let name = null;
                if (component.name) {
                  name = component.name;
                } else if (component.type) {
                  name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
                }
                if (name === 'Cta') {
                  let classNames = [];
                  // 2個以上ある場合は50%にする
                  if (2 <= components.length) {
                    classNames.push('multiple');
                  }
                  // リンクタイプがボタンかテキストか
                  classNames.push('linkType__' + component.props.linkType);

                  // テキスト（Text）リンク、はFreeでもなんでも矢印アイコンになる
                  if (component.props.linkType === 'Text') {
                    classNames.push('color__' + component.props.color);
                    classNames.push('buttonStyle__' + component.props.buttonStyle);
                    classNames.push('withArrowIcon');
                  } else {
                    classNames.push('color__' + component.props.color);
                    classNames.push('buttonStyle__' + component.props.buttonStyle);
                  }
                  return (
                    <li className={classNames.join(' ')} key={index}>
                      <div className="PromoAndButtonModalWindow__box">
                        <Cta {...component.props} />
                      </div>
                    </li>
                  )
                }
              })
            )
          })()}
        </ul>
      )
    } else {
      return null;
    }
  }

  render() {
    const {
      containerId,
      containerClass,
      deleteIconOnPromo,
      linkItem,
      promo,
      linkButtonText,
      modal,
      getRef,
      hasBackground,
      parentColumn,
    } = this.props;
    return (
      <Wrapper containerId={containerId} containerClass={containerClass}>
        <div
          className={'PromoAndButtonModalWindow' + ((modal && modal.modalId) ? ` ${modal.modalId}` : '')}
          ref={component => (this.refs = component)}
        >
          {(()=> {
            if (linkItem === 'Promo') {
              return (
                <ScrollLoaderForPromoItem>
                  <PromoItem {...promo}
                    getRef={getRef}
                    hasBackground={hasBackground}
                    parentColumn={parentColumn}
                    deleteIconOnPromo={deleteIconOnPromo}
                    openModal={()=> {
                      this.openModal();
                    }}
                    ref={component => (this.refsPromoItem = component)}
                  />
                  {this.renderCta()}
                </ScrollLoaderForPromoItem>
              )
            } else if (linkItem === 'Link-Button-Text') {
              return (
                <CtaItem {...linkButtonText} openModal={()=> {
                  this.openModal();
                }} />
              );
            }
          })()}
          {(()=> {
            if (this.state.isModalOpened) {
              return (
                <ModalItem {...modal} closeModal={()=> {
                  this.closeModal();
                }} />
              )
            } else {
              return null;
            }
          })()}
        </div>
      </Wrapper>
    );
  }
}

class PromoItem extends Component {
  static propTypes = {
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    videoSrc: PropTypes.string,
    loop: PropTypes.bool,
    pcLayout: PropTypes.string,
    mbLayout: PropTypes.string,
    backgroundColor: PropTypes.string,
    // ctaButton: PropTypes.array,
    getRef: PropTypes.func,
    hasBackground: PropTypes.bool,
    parentColumn: PropTypes.string,
    openModal: PropTypes.func,
    deleteIconOnPromo: PropTypes.bool,
  };
  static defaultProps = {
    pcDescription: null,
    mbDescription: null,
    pcSrc: null,
    mbSrc: null,
    videoSrc: null,
    loop: null,
    pcLayout: null,
    mbLayout: null,
    backgroundColor: null,
    // ctaButton: null,
    getRef: null,
    hasBackground: false,
    parentColumn: null,
    openModal: null,
    deleteIconOnPromo: false,
  };

  static imgTag(src, suffix = '', baseClass = 'PromoAndButtonModalWindow-Promo__image') {
    if (!src) return null;
    return <img src={src} alt="" className={`${baseClass} ${baseClass}${(suffix) ? '-': ''}${suffix}`} />
  }

  static descriptionTag(description, suffix = '', baseClass = 'PromoAndButtonModalWindow-Promo__wysiwyg') {
    if (!description) return null;
    return (
      <div
        className={`${baseClass}${(suffix) ? '-': ''}${suffix}` + ' Wysiwyg'}
        dangerouslySetInnerHTML={{__html: description}}
      />
    );
  }

  static convert(className) {
    return className.toLowerCase().replace(/[\/|:]/g, '_').replace(/[)]/g, '').replace(/[(]/g, '-');
  }

  constructor(props) {
    super(props);
    if (this.props.getRef) this.props.getRef(this);
    this.state = {
      containerHeight: null,
      isPlayed: false,
      ended: false,
      //loadedPcImg: false,
      //loadedMbImg: false,
      openedImg: false,
    };
    this.refsContainer = null;
    this.refsVideo = null;
  }

  getContentsHeight() {
    // console.log('getContentsHeight', this.refsContainer.clientHeight);
    return this.refsContainer.clientHeight;
  }

  setContainerHeight(height) {
    // console.log('setContainerHeight', height);
    if (this.state.containerHeight !== height) {
      this.setState({
        containerHeight: height,
      });
    }
  }

  clearContainerHeight() {
    return null;
    // if (this.state.containerHeight !== null) {
    //   this.setState({
    //     containerHeight: null,
    //   });
    // }
  }

  componentDidMount() {
    const {
      videoSrc,
      loop,
    } = this.props;

    const ua = NAVIGATOR.userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      setTimeout(()=> {
        this.setState({
          openedImg: true,
        })
      }, 100);
    } else {
      this.setState({
        openedImg: true,
      })
    }

    //
    if (videoSrc) {
      if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi) {
        this.setState({
          played: true,
        });
      } else {
        WINDOW.addEventListener('resize', this.handleScrollAndResize);
        WINDOW.addEventListener('scroll', this.handleScrollAndResize);
        setTimeout(() => {
          this.handleScrollAndResize();
        }, 200);
      }
    } else {
      this.setState({
        played: true,
      });
    }
    //
    if (this.refsVideo) {
      this.refsVideo.addEventListener('ended', ()=> {
        this.setState({
          ended: true,
        })
        if (!loop) {
          this.refsVideo.load();
          this.refsVideo.autoplay = false;
        }
      }, false);
    }
  }

  componentWillUnmount() {
    const {
      videoSrc,
    } = this.props;
    //
    if (videoSrc) {
      WINDOW.removeEventListener('resize', this.handleScrollAndResize);
      WINDOW.removeEventListener('scroll', this.handleScrollAndResize);
    }
  }

  handleScrollAndResize = () => {
    const element = this.refsContainer;
    if (!element) return;
    const scrollTop = WINDOW.pageYOffset;
    const clientRect = element.getBoundingClientRect();
    const top = scrollTop + clientRect.top;
    const windowHeight = WINDOW.innerHeight;
    const videoHeight = this.refsVideo.getBoundingClientRect().height;
    if (top <= scrollTop + windowHeight && (scrollTop - videoHeight) < top) {
      if (!this.state.isPlayed) {
        this.setState({
          isPlayed: true,
        });
        this.playVideo();
      }
    } else {
      if (this.state.isPlayed) {
        this.setState({
          isPlayed: false,
        });
        this.pauseVideo();
      }
    }
  };

  playVideo() {
    const {
      loop,
    } = this.props;
    //
    if (!this.refsVideo) return;
    //
    if (this.state.ended && !loop) return;
    //再生
    try {
      this.refsVideo.play();
    } catch (e) {
      console.warn('PromoAndButtonModalWindow', e);
    }
  }

  pauseVideo() {
    if (!this.refsVideo) return;
    //一時停止
    try {
      this.refsVideo.pause();
    } catch (e) {
      console.warn('PromoAndButtonModalWindow', e);
    }
  }

  render() {
    const {
      pcSrc,
      mbSrc,
      videoSrc,
      loop,
      pcDescription,
      mbDescription,
      pcLayout,
      mbLayout,
      openModal,
      deleteIconOnPromo,
    } = this.props;

    const renderFigures = ()=> {
      const pcImg = pcSrc || '';
      const mbImg = mbSrc || pcImg;
      if (!pcImg && !mbImg) {
        return null;
      }

      // テキストの有無
      let hasDescription = true;
      const pcHtml = pcDescription || '';
      const mbHtml = mbDescription || pcHtml;
      if (!pcHtml && !mbHtml) {
        hasDescription = false;
      }

      // setTimeout(()=> {
      //   this.setState({
      //     openedImg: true,
      //   })
      // }, 100);

      let isIE = false;
      const ua = NAVIGATOR.userAgent.toLowerCase();
      if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
        isIE = true;
      }

      return (
        <div className={'PromoAndButtonModalWindow-Promo__image__block' + ((isIE || this.state.openedImg) ? ' opened' : '')}
             style={(!hasDescription) ? {width: '100%'} : null}>
          {PromoItem.imgTag(pcImg, 'pc')}
          {PromoItem.imgTag(mbImg, 'mb')}
        </div>
      );

      /*
      // PC用画像読み込み
      if (!this.state.loadedPcImg) {
        const pcImage = new Image();
        pcImage.onload = ()=> {
          setTimeout(()=> {
            this.setState({
              loadedPcImg: true,
            })
          }, 1000)
        }
        pcImage.src = pcImg;
      }

      // MB用画像読み込み
      if (!this.state.loadedMbImg) {
        const mbImage = new Image();
        mbImage.onload = ()=> {
          this.setState({
            loadedMbImg: true,
          })
        }
        mbImage.src = mbImg;
      }

      if (this.state.loadedMbImg && this.state.loadedPcImg) {
        setTimeout(()=> {
          this.setState({
            openedImg: true,
          })
        }, 100);
        return (
          <div className={'PromoAndButtonModalWindow-Promo__image__block' + ((this.state.openedImg) ? ' opened' : '')}
               style={(!hasDescription) ? {width: '100%'} : null}>
            {PromoItem.imgTag(pcImg, 'pc')}
            {PromoItem.imgTag(mbImg, 'mb')}
          </div>
        );
      } else {
        return (
          <div className="PromoAndButtonModalWindow-Promo__image__block"
               style={(!hasDescription) ? {width: '100%'} : null}>
            <div className="PromoAndButtonModalWindow-Promo__image__blank">
              <span>&nbsp;</span>
            </div>
          </div>
        );
      }
     */

    }

    const renderVideo = ()=> {
      if (!videoSrc) return;
      let poster = null;
      const pcImg = pcSrc || '';
      const mbImg = mbSrc || pcImg;
      if (IS_MOBILE) {
        poster = mbImg;
      } else {
        poster = pcImg;
      }
      return (
        <div className="PromoAndButtonModalWindow-Promo__video__block">
          <video className="PromoAndButtonModalWindow-Promo__video"
                 src={videoSrc}
                 poster={poster}
                 autoPlay={true}
                 loop={loop}
                 muted={true}
                 playsInline={true}
                 controls={false}
                 ref={component => (this.refsVideo = component)}
          />
        </div>
      )
    }

    const renderDescriptions = ()=> {
      const pcHtml = pcDescription || '';
      const mbHtml = mbDescription || pcHtml;
      if (!pcHtml && !mbHtml) {
        return null;
      }

      // 画像の有無
      let hasFigure = true;
      const pcImg = pcSrc || '';
      const mbImg = mbSrc || pcImg;
      if (!pcImg && !mbImg) {
        hasFigure = false;
      }

      return (
        <div className="PromoAndButtonModalWindow-Promo__text__block"
             style={(!hasFigure) ? {width: '100%'} : null}>
          <div className="PromoAndButtonModalWindow-Promo__wysiwyg">
            {PromoItem.descriptionTag(pcHtml, 'pc')}
            {PromoItem.descriptionTag(mbHtml, 'mb')}
          </div>
        </div>
      );
    }

    const figures = renderFigures();
    const video = renderVideo();
    const descriptions = renderDescriptions();
    if (!video && !figures && !descriptions) {
      return null;
    }

    const layout = (()=> {
      const pcClass = pcLayout || 'Image-On-Top';
      const mbClass = mbLayout || pcClass;
      return {
        pc: `pcLayout__${PromoItem.convert(pcClass)}`,
        mb: `mbLayout__${PromoItem.convert(mbClass)}`,
      };
    })();

    let layout2 = null;
    if (this.props.hasBackground || (this.props.backgroundColor && this.props.backgroundColor !== '')) {
      layout2 = 'hasBackground';
      if (this.props.parentColumn === 'oneColumnLayout') {
        layout2 = 'hasBackground oneColumnLayout';
      } else if (this.props.parentColumn === 'twoColumnLayout') {
        layout2 = 'hasBackground twoColumnLayout';
      } else if (this.props.parentColumn === 'threeColumnLayout') {
        layout2 = 'hasBackground threeColumnLayout';
      } else if (this.props.parentColumn === 'fourColumnLayout') {
        layout2 = 'hasBackground fourColumnLayout';
      }
    }

    const deleteIconOnPromoClass = ()=> {
      if (deleteIconOnPromo) return ' deleteIcon';
      if ((figures || video) && !descriptions) return ' deleteIcon';
      return '';
    }

    return (
      <div className={`PromoAndButtonModalWindow-Promo ${layout.pc} ${layout.mb}` + ((layout2) ? ' ' + layout2 : '') + deleteIconOnPromoClass()}>
      {/*<div className={`PromoAndButtonModalWindow-Promo ${layout.pc} ${layout.mb}` + ((layout2) ? ' ' + layout2 : '') + ((deleteIconOnPromo) ? ' deleteIcon' : '')}>*/}
        <a className="PromoAndButtonModalWindow-Promo__link" onClick={()=> {
          if (openModal) openModal();
        }} style={(this.props.backgroundColor) ? {backgroundColor: '#' + this.props.backgroundColor.replace(/#/g, '')}: null}>
          <div className="PromoAndButtonModalWindow-Promo__wrapper" style={(descriptions && this.state.containerHeight) ? {height: this.state.containerHeight}: null}>
            <div className="PromoAndButtonModalWindow-Promo__container" ref={component => (this.refsContainer = component)}>
              {(()=> {
                if (video) {
                  return video;
                } else {
                  return figures;
                }
              })()}
              {descriptions}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

class CtaItem extends Component {
  static propTypes = {
    linkText: PropTypes.string,
    linkType: PropTypes.string,
    buttonColor: PropTypes.string,
    ctaButtonStyle: PropTypes.string,
    additionalClass: PropTypes.string,
    openModal: PropTypes.func,
  };
  static defaultProps = {
    linkText: null,
    linkType: null,
    buttonColor: null,
    ctaButtonStyle: null,
    additionalClass: null,
    openModal: null,
  };

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {
    const {
      linkText,
      linkType,
      buttonColor,
      ctaButtonStyle,
      additionalClass,
      openModal,
    } = this.props

    const ctaContainerAttrs = {
      className: [
        'PromoAndButtonModalWindow-Cta__container',
        (buttonColor && buttonColor !== '') ? 'PromoAndButtonModalWindow-Cta__container--' + buttonColor : null
      ].join(' ')
    }

    const renderText = ()=> {
      return (
        (linkText && linkText !== '') ? <span className="PromoAndButtonModalWindow-Cta__button__text">{linkText}</span> : ''
      )
    }

    const renderIcon = ()=> {
      let icon = IconOpenWhite;
      let hoverIcon = IconOpenBlack;
      if (buttonColor === 'Light') {
        if (ctaButtonStyle === 'Action') {
          if (linkType === 'Text') {
            icon = IconOpenWhite;
            hoverIcon = IconOpenBlack;
          } else {
            icon = IconOpenBlack;
            hoverIcon = IconOpenWhite;
          }
        } else {
          icon = IconOpenWhite;
          hoverIcon = IconOpenBlack;
        }
      } else if (buttonColor === 'Dark') {
        if (ctaButtonStyle === 'Action') {
          if (linkType === 'Text') {
            icon = IconOpenBlack;
            hoverIcon = IconOpenWhite;
          } else {
            icon = IconOpenWhite;
            hoverIcon = IconOpenBlack;
          }
        } else {
          icon = IconOpenBlack;
          hoverIcon = IconOpenWhite;
        }
      }
      return (
        <span className="PromoAndButtonModalWindow-Cta__button__icon__container">
            <img alt="" src={icon} className="PromoAndButtonModalWindow-Cta__button__icon" />
            <img alt="" src={hoverIcon} className="PromoAndButtonModalWindow-Cta__button__icon--hover" />
          </span>
      )
    }

    return (
      <div className="PromoAndButtonModalWindow-Cta">
        <div {...ctaContainerAttrs}>
          <a
            onClick={()=>{
              if (openModal) openModal();
            }}
            className={(() => (
              [
                'PromoAndButtonModalWindow-Cta__button',
                (linkType && linkType !== '') ? 'PromoAndButtonModalWindow-Cta__button--linkType--' + linkType : null,
                (ctaButtonStyle && ctaButtonStyle !== '') ? 'PromoAndButtonModalWindow-Cta__button--buttonStyle--' + ctaButtonStyle : null,
                (additionalClass && additionalClass !== '') ? additionalClass : null,
              ].join(' ')
            ))()}>
              {renderText()}
              {renderIcon()}
          </a>
        </div>
      </div>
    )
  }
}

class ModalItem extends Component {
  static propTypes = {
    pcContents: PropTypes.array,
    mbContents: PropTypes.array,
    modalId: PropTypes.string,
    closeModal: PropTypes.func,
  };
  static defaultProps = {
    pcContents: null,
    mbContents: null,
    modalId: null,
    closeModal: null,
  };

  constructor(props) {
    super(props)
    this.state = {
      isOpened: false,
      scrollTop: 0,
    }
    this.onScroll = this.onScroll.bind(this);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.containerRef.current.addEventListener('scroll', this.onScroll);

    const ua = NAVIGATOR.userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {

      this.setState({
        isOpened: true,
      })

      // GTMイベント
      if (this.props.modalId && this.props.modalId !== '') {
        WINDOW.dataLayer = WINDOW.dataLayer || [];
        WINDOW.dataLayer.push({
          trackmodalId: this.props.modalId,
          event: 'loadmodal'
        });
      }

    } else {

      WINDOW.requestAnimationFrame(()=> {

        this.setState({
          isOpened: true,
        })

        // GTMイベント
        if (this.props.modalId && this.props.modalId !== '') {
          WINDOW.dataLayer = WINDOW.dataLayer || [];
          WINDOW.dataLayer.push({
            trackmodalId: this.props.modalId,
            event: 'loadmodal'
          });
        }

      });

    }
  }

  componentWillUnmount() {
    this.containerRef.current.removeEventListener('scroll', this.onScroll);
    this.setState({
      isOpened: false,
    })
  }

  onScroll() {
    this.setState({
      scrollTop: this.containerRef.current.scrollTop,
    })
  }

  getNestedComponents = (components) => {
    return (
      components.map((component, index) => {
        let name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
        }
        let Block = blocks[name];
        if (Block) {
          if (1 <= this.state.scrollTop) {
            if (index < 4) {
              return (
                <Block {...component.props} key={index} />
              )
            } else {
              return (
                <ScrollLoaderForModalItem scrollTop={this.state.scrollTop}  key={index}>
                  <Block {...component.props} />
                </ScrollLoaderForModalItem>
              )
            }
          } else {
            if (index < 4) {
              return (
                <Block {...component.props} key={index} />
              )
            }
          }
        } else {
          return null;
        }
      })
    )
  };

  renderContents() {
    const {
      pcContents,
      mbContents,
    } = this.props
    if (IS_MOBILE && mbContents && 1 <= mbContents.length) {
      return this.getNestedComponents(mbContents);
    } else if (pcContents && 1 <= pcContents.length) {
      return this.getNestedComponents(pcContents);
    } else {
      return null;
    }
  }

  render() {
    const {
      closeModal,
    } = this.props

    let isIE = false;
    const ua = NAVIGATOR.userAgent.toLowerCase();
    if (ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0) {
      isIE = true;
    }

    return (
      <div className="PromoAndButtonModalWindow-Modal">
        <a className="PromoAndButtonModalWindow-Modal__link-close5" onClick={()=> {
          if (closeModal) closeModal();
        }}>閉じる</a>
        <div className="PromoAndButtonModalWindow-Modal__container2">
          <a className="PromoAndButtonModalWindow-Modal__link-close" onClick={()=> {
            if (closeModal) closeModal();
          }}>閉じる</a>
        </div>
        <div className="PromoAndButtonModalWindow-Modal__container" ref={this.containerRef}>
          <a className="PromoAndButtonModalWindow-Modal__link-close4" onClick={()=> {
            if (closeModal) closeModal();
          }}>閉じる</a>
          <div className="PromoAndButtonModalWindow-Modal__container3">
            <a className="PromoAndButtonModalWindow-Modal__link-close3" onClick={()=> {
              if (closeModal) closeModal();
            }}>閉じる</a>
            <div className={`PromoAndButtonModalWindow-Modal__contents` + ((isIE || this.state.isOpened) ? ' isOpened' : '')}>
              <hr className="PromoAndButtonModalWindow-Modal__rule" />
              {(this.state.isOpened) ? this.renderContents() : null}
              <a className="PromoAndButtonModalWindow-Modal__link-close2" onClick={()=> {
                if (closeModal) closeModal();
              }}><span>閉じる</span></a>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

// PromoItem用のスクロールローダー
class ScrollLoaderForPromoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    let isPromoModal = false;
    if (this.ref.current) {
      let parentElement = this.ref.current.closest('.FeatureCategories') || null;
      if (!parentElement) {
        parentElement = this.ref.current.closest('.PromoAndButtonModalWindow-Modal') || null;
      }
      if (parentElement) {
        isPromoModal = true;
      }
    }

    if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true,
      });
    } else if (isPromoModal) {
      // プロモモーダルブロックのモーダル内の処理
      this.setState({
        opened: true,
      });
    } else {
      WINDOW.addEventListener('resize', this.handleScrollAndResize);
      WINDOW.addEventListener('scroll', this.handleScrollAndResize);
      this.handleScrollAndResize();
      setTimeout(() => {
        this.handleScrollAndResize();
      }, 200);
    }
  }

  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.handleScrollAndResize);
    WINDOW.removeEventListener('scroll', this.handleScrollAndResize);
  }

  render() {
    return (
      <div className={'ScrollLoader' + ((this.state.opened === true)  ? ' opened' : '')} ref={this.ref}>
        {(this.state.opened === true)  ? this.props.children : null}
      </div>
    );
  }

  //
  handleScrollAndResize = () => {
    if (this.state.opened === true) return;
    const element = this.ref.current;
    const scrollTop = WINDOW.pageYOffset;
    const clientRect = element.getBoundingClientRect();
    const top = scrollTop + clientRect.top;
    const windowHeight = WINDOW.innerHeight;
    if (top <= scrollTop + windowHeight) {
      if (this.state.opened === false) {
        this.setState({
          opened: true,
        });
        WINDOW.removeEventListener('resize', this.handleScrollAndResize);
        WINDOW.removeEventListener('scroll', this.handleScrollAndResize);
      }
    }
  };

}

// ModalItem内のスクロールローダー
class ScrollLoaderForModalItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
    this.intervalId = null;
    this.ref = React.createRef();
  }

  componentDidMount() {
    if(WINDOW !== WINDOW.parent && WINDOW.parent.EPi) {
      // 編集プレビュー時の処理
      this.setState({
        opened: true,
      });
    } else {
      this.intervalId = setInterval(()=> {
        this.handleScrollAndResize();
      }, 200);
    }
  }

  componentWillUnmount() {
    if (this.intervalId) clearInterval(this.intervalId);
  }

  handleScrollAndResize = () => {
    if (this.state.opened) return;
    const element = this.ref.current;
    if (element) {
      const scrollTop = this.props.scrollTop;
      const top = element.offsetTop;
      const windowHeight = WINDOW.innerHeight;
      if (top <= scrollTop + windowHeight) {
        if (this.state.opened === false) {
          this.setState({
            opened: true,
          });
          if (this.intervalId) clearInterval(this.intervalId);
        }
      }
    }
  };

  render() {
    return (
      <div className={'ScrollLoader' + ((this.state.opened === true)  ? ' opened' : '')} ref={this.ref}>
        {(this.state.opened === true)  ? this.props.children : null}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/promo-and-button-modal-window/index.jsx